// Rapha-branded design tokens — overrides the default aero.chat palette.
// Rapha's brand identity is dark and premium with a signature pink accent.

export const raphaColors = {
  // Base surface stack — slightly warmer dark tones
  bg: '#0A0C14',
  bgSubtle: '#0E1018',
  surface: '#12141C',
  surfaceElevated: '#1A1C26',
  surfaceHigh: '#23252F',

  // Borders / dividers
  border: 'rgba(255, 255, 255, 0.08)',
  borderStrong: 'rgba(255, 255, 255, 0.14)',
  borderFocus: 'rgba(204, 0, 95, 0.5)',

  // Text
  text: '#E4E9F2',
  textMuted: '#8B95A8',
  textFaint: '#5A647A',
  textInverse: '#FFFFFF',

  // Brand — Rapha pink
  brand: '#CC005F',
  brandBright: '#E6197A',
  brandDim: '#A30050',
  brandShadow: 'rgba(204, 0, 95, 0.35)',

  // Data viz secondary — keep cyan for contrast
  data: '#00D9FF',
  dataDim: '#0099B5',

  // Semantic
  success: '#6AFF45',
  warning: '#FFB547',
  danger: '#FF4757',
  info: '#00D9FF',

  // Gradients
  gradBrand: 'linear-gradient(135deg, #CC005F 0%, #E6197A 100%)',
  gradData: 'linear-gradient(135deg, #00D9FF 0%, #CC005F 100%)',
  gradSurface:
    'linear-gradient(180deg, rgba(26, 28, 38, 0.8) 0%, rgba(18, 20, 28, 0.8) 100%)',
  gradHero:
    'radial-gradient(ellipse at top, rgba(204, 0, 95, 0.12) 0%, transparent 60%), radial-gradient(ellipse at bottom right, rgba(0, 217, 255, 0.08) 0%, transparent 50%)',
};
